module.exports = __webpack_public_path__ + "static/media/mobileScreenshot06.5c0f42da.jpg";